import {
  NotificationsList,
  defaultNotifier,
  TNotificationId,
  INotification,
  TDispatchedNotification,
  TNotificationSelector,
} from '@apia/notifications';

export class ApiaUtilNotifications {
  close = (id: TNotificationId | INotification) => {
    defaultNotifier.close(id);
  };

  closeAll = () => {
    defaultNotifier.closeAll();
  };

  notify = (notification: TDispatchedNotification): void => {
    defaultNotifier.notify({
      ...notification,
      type: notification.type ?? 'warning',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useSelector = (selector: TNotificationSelector<any>) =>
    defaultNotifier.useSelector(selector);

  Component = () => {
    return <NotificationsList />;
  };
}
